<template>
    <div class="section reset-password-section">
      <div class="container">
      <div class="columns is-centered">
        <div class="column is-half ">

          <img src="@/assets/truckl-logo.png" class="logo"
          >
          <h1 class="title">Password Reset</h1>

          <div class="card">
            <p class="content has-background-white">
              Please provide the email address you registered with Truckl in the field below.
              <br/>
              We will send you simple instructions on how to reset your password.
            </p>

            <reset-form :preset-validation-code="confirmationCode" class="reset-form" />
          </div>

        </div>
      </div>
      </div>
    </div>
</template>

<script>
import ResetForm from '@/components/FormForgotPassword'
export default {
  name: 'PasswordReset',

  data() {
    return {
      confirmationCode: null
    }
  },

  created() {
    if (this.$route.query.hasOwnProperty('hasCode')) {
      // if there is a code in the URL, pre-populate it
      this.confirmationCode = this.$route.query.hasCode
    }
  },

  components: {
    ResetForm
  }
}
</script>

<style scoped lang="scss">
.section {
  text-align: center;

  &::after {
    content: '';
    background-image: url('../assets/backgrounds/image001.jpg');
    background-size: cover;
    // background-position: 0 -90px;
    background-repeat: no-repeat;
    opacity: 0.5;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: fixed;
    z-index: -1;
  }
}

.logo {
  margin-bottom: 80px;
}

.reset-form {
  width: 70%;
  margin: auto;
}

.card {
  padding: 16px;
}

@media only screen and (max-width: 600px) {
  .logo {
    height: 5vh;
    margin-bottom: 20px;
  }

  .card {
    padding: 3px;
  }

  .reset-password-section {
    padding: 8px;
  }

  .reset-form {
    width: 90%;
  }
}
</style>
